const de = {
  app: {
    label: {
      true: 'Ja',
      false: 'Nein',
    },
    loginWidget: {
      email: 'E-Mail',
      forgotPassword: 'Passwort vergessen?',
      login: 'Einloggen',
      loginWelcome:
        'Willkommen zurück. Bitte loggen Sie sich mit Ihren Zugangsdaten ein.',
      next: 'Weiter',
      password: 'Passwort',
      title: 'Login',
    },
    resetWidget: {
      title: 'Passwort vergessen?',
      instructions:
        'Bitte geben Sie Ihre registrierte E-Mail-Adresse ein. Sollte ein Zugang mit dieser E-Mail-Adresse existieren, erhalten Sie Informationen zur Zurücksetzung des Passworts.',
      emailLabel: 'E-Mail-Adresse',
      emailPlaceholder: 'Geben Sie Ihre E-Mail-Adresse ein',
      back: 'Zurück zum Login',
      submit: 'Abschicken',
      submitSso: 'Zum Single Sign-On Portal',
    },
    resetConfirmationWidget: {
      title: 'Neues Passwort wurde angefragt',
      confirmation:
        'Bitte prüfen Sie Ihr E-Mail-Postfach für weitere Informationen.',
      back: 'Zurück zum Login',
    },
    changePasswordWidget: {
      title: 'Passwort setzen',
      forcedTitle: 'Passwort zurücksetzen',
      instructions:
        'Bitte setzen Sie Ihr neues persönliches Passwort unter Beachtung unserer Sicherheitsempfehlungen.',
      placeholder: 'Passwort',
      newPasswordLabel: 'Bitte geben Sie Ihr neues Passwort ein',
      confirmationLabel: 'Wiederholen Sie Ihr neues Passwort',
      confirmationError: 'Die Passworteingaben stimmen nicht überein',
      backToLogin: 'Zum Login',
      back: 'Zurück',
      submit: 'Passwort setzen',
      recommendations: {
        characterCount: 'mind. 10 Zeichen',
        containing: 'bestehend aus',
      },
    },
    logout: 'Abmelden',
    inactivityLogout:
      'Sie wurden aufgrund von Inaktivität aus Sicherheitsgründen ausgeloggt. Bitte loggen Sie sich mit Ihren Zugangsdaten erneut ein.',
    changePassword: 'Passwort ändern',
    settings: 'Einstellungen',
    radioGroup: {
      current: 'Aktuell',
    },
    userSettings: {
      title: 'Benutzereinstellungen',
      loginInformation: 'Anmeldeinformationen',
      loginDescription:
        'Sehen Sie Ihre Kontoinformationen ein und ändern Sie Ihr Passwort',
      portalSettings: 'Portaleinstellungen',
      email: 'E-Mail',
      language: 'Portalsprache',
      colorMode: 'Farbmodus',
      lightMode: 'Heller Modus',
      darkMode: 'Dunkler Modus',
      cancel: 'Abbrechen',
      saveAndExit: 'Speichern & Schließen',
    },
    genericListWithLayoutModal: {
      title: 'Vergleichseinstellungen',
      cancel: 'Abbrechen',
      apply: 'Vergleichen',
      layoutLabel: 'Layout',
    },
    switchToLightTheme: 'Helles Design aktivieren',
    switchToDarkTheme: 'Dunkles Design aktivieren',
    page: {
      loadingError: 'Fehler beim Laden der Anwendung',
      genericError: 'Es ist ein Fehler aufgetreten',
      pageNotFoundError: 'Seite nicht gefunden',
      unknownPageContentNodeError: 'Unbekannter Seiteninhalt',
      retry: 'Neu laden',
      notLoadedTitle: 'Die Seite konnte nicht geladen werden',
      notLoadedErrorText:
        'Die gesuchte Seite existiert nicht oder es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie den Kundensupport.',
      pageContentErrorTitle: 'Fehler beim Seiteninhalt',
      contentNotFoundError:
        'Beim Laden des Inhalts ist ein Problem aufgetreten. Bitte aktualisieren Sie die Seite oder versuchen Sie es später erneut.',
      backToDashboard: 'Zurück zum Dashboard',
      close: 'Detail-Seite schließen',
      editAction: {
        label: {
          customizePage: 'Seite anpassen',
          archive: 'Archivieren',
          delete: 'Löschen',
          share: 'Teilen',
          addComponent: 'Komponente hinzufügen',
          save: 'Speichern',
        },
        addComponentModal: {
          title: 'Komponente hinzufügen',
          cancel: 'Abbrechen',
          add: 'Komponenten hinzufügen',
          emptyCategories:
            'Es sind keine Content-Library-Kategorien konfiguriert.',
          noResults: 'Keine passenden Komponenten gefunden.',
          untitled: 'Ohne Titel',
          loadError:
            'Content-Library-Daten konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
          searchError:
            'Komponenten konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
          selectComponentsInstruction:
            'Wählen Sie eine oder mehrere Komponenten aus, die Sie zu Ihrem Dashboard hinzufügen möchten.',
          tables: 'Tabellen',
          charts: 'Diagramme',
        },
      },
    },
    pageFilter: {
      placeholder: 'Alle',
      reset: 'Filter zurücksetzen',
      autoSaveEnabled: 'Filterauswahl wird automatisch gespeichert',
      autoSaveDisabled: 'Filterauswahl wird nicht automatisch gespeichert',
      autoSaveForceEnabled:
        'Filterauswahl wird automatisch gespeichert. Dies kann nicht deaktiviert werden.',
      manualSave: 'Aktuelle Filterauswahl speichern',
      calendarFilter: {
        defaultTitle: 'Datum',
        placeholder: 'Datum auswählen',
      },
      dateRangeFilter: {
        placeholderFrom: 'Von',
        placeholderTo: 'Bis',
      },
      monthRangeFilter: {
        presets: {
          qtd: 'QTD',
          ytd: 'YTD',
          sinceInception: 'Seit Auflage',
        },
      },
      comparisonFilter: {
        baseEntity: 'Basisentität',
        comparisonEntity: 'Vergleichsentität',
        multipleComparisonFiltersError:
          'Konfigurationsfehler: Pro Seite ist nur ein Vergleichsfilter erlaubt.',
      },
    },
    pagination: {
      summary:
        '{{firstShownEntry, number}} - {{lastShownEntry, number}} von {{totalEntries, number}} Einträgen',
      summaryShort:
        '{{totalEntries, number}} von {{totalEntries, number}} Einträgen',
      selectItem: '{{entries, number}} pro Seite',
      selectedRows: '{{selectedRowsCount, number}} ausgewählt',
      entryLimit: ' (auf {{totalEntries, number}} Einträge begrenzt)',
    },
    pageReference: {
      reference_one: 'S. {{pages}}',
      reference_other: 'S. {{pages}}',
    },
    table: {
      tooltip: {
        maliciousContent:
          'Unsere Überprüfung hat ergeben, dass diese Datei potentiell schädliche Daten beinhaltet. Sie ist daher für sämtliche Aktionen gesperrt.',
      },
      searchResultPagination:
        '{{shownResults, number}} von {{totalResults, number}} Ergebnissen',
      customizationModal: {
        title: 'Tabelleneinstellungen',
        divider: 'Spalten über dieser Linie werden fixiert dargestellt',
        groupedDivider:
          'Die Tabelle wird nach Spalten über dieser Linie gruppiert',
        resetChanges: 'Auf Standardeinstellungen zurücksetzen',
        cancel: 'Abbrechen',
        apply: 'Speichern & Schließen',
        selectAll: 'Alle auswählen',
        groupingHeader:
          'Sie können diese Tabelle nach bis zu {{maxColumns, number}} Spalten gleichzeitig gruppieren.',
        groupingNote:
          'Bitte beachten Sie, dass nur bestimmte Spalten zur Gruppierung genutzt werden können.',
      },
      filterModal: {
        title: 'Filtereinstellungen',
        resetChanges: 'Alle Filter löschen',
        cancel: 'Abbrechen',
        apply: 'Speichern & Schließen',
        selectAll: 'Alle auswählen',
      },
      showMoreEntry_one: '+ {{ count }} Eintrag mehr',
      showMoreEntry_other: '+ {{ count }} Einträge mehr',
      workflowActionModal: {
        apply: 'Bestätigen',
        cancel: 'Abbrechen',
        successMessage: 'Die Aktion wurde erfolgreich ausgeführt.',
        fileUploadRequired: 'Es muss mindestens eine Datei ausgewählt werden.',
        actionSuccessfulCountTimes_one:
          'Die Aktion wurde für {{ count }} Element erfolgreich ausgeführt,',
        actionSuccessfulCountTimes_other:
          'Die Aktion wurde für {{ count }} Elemente erfolgreich ausgeführt,',
        actionFailedCountTimes_one:
          'ist jedoch für {{ count }} Element gescheitert',
        actionFailedCountTimes_other:
          'ist jedoch für {{ count }} Elemente gescheitert',
      },
      documentSigning: {
        initializationErrorNotification:
          'Es ist ein Fehler während der Initialisierung der Dokumenten-Signierung aufgetreten',
        finalizingErrorNotification:
          'Es ist ein Fehler beim Abschluss der Dokumenten-Signierung aufgetreten',
        finalizingNotification: 'Finalisiere Dokumenten-Signierung',
        successNotification: 'Die Dokumenten-Signierung war erfolgreich',
      },
      deleteConfirmation: {
        cancel: 'Abbrechen',
        apply: 'Löschen',
        title: 'Löschen',
        message_one: 'Möchten Sie diese Zeile wirklich löschen?',
        message_other: 'Möchten Sie diese {{count}} Zeilen wirklich löschen?',
      },
    },
    monthQuarterPicker: {
      modeMonthly: 'Monatlich',
      modeQuarterly: 'Quartalsweise',
      placeholderMonth: 'Monat auswählen',
      placeholderQuarter: 'Quartal auswählen',
      placeholderYear: 'Jahr auswählen',
    },
    periodPicker: {
      month: 'Monat',
      quarter: 'Quartal',
    },
    periodRangePicker: {
      earlier: 'Frühere Zeiträume',
      from: 'Von',
      later: 'Spätere Zeiträume',
      to: 'Bis',
    },
    datepicker: {
      qtd: 'Quartal bis heute',
      qtdShort: 'QTD',
      ytd: 'Jahr bis heute',
      ytdShort: 'YTD',
      ltm: 'Letzte 12 Monate',
      ltmShort: 'LTM',
      sinceInception: 'Alle Tage bis heute',
      sinceInceptionShort: 'Seit Auflage',
    },
    select: {
      noOptionsAvailable: 'Keine Auswahlmöglichkeiten verfügbar',
      noOptionsFound:
        'Keine Auswahlmöglichkeiten für diesen Suchbegriff verfügbar',
      createOption: '"{{value}}" erstellen',
      creatableHint:
        'Neue Einträge können durch Eingabe in das Feld hinzugefügt werden.',
      selectAbove: 'Alle Auswahlmöglichkeiten selektieren',
    },
    search: {
      placeholder: 'Suche',
    },
    noAccessError: {
      headline: 'Fehlende Berechtigungen',
      message:
        'Sie benötigen weitere Zugriffsrechte, um diese Anwendung nutzen zu können.',
      resolution:
        'Tritt dieser Fehler unerwartet auf, kontaktieren Sie bitte Ihren Kundensupport.',
      logoutButton: 'Abmelden',
    },
    fullScreenError: {
      loadingError: 'Fehler beim Laden der Anwendung',
      genericError: 'Es ist ein Fehler aufgetreten',
      actions: {
        retry: 'Neu laden',
        logout: 'Abmelden',
      },
      tenantNotFound: {
        headline: 'Kundenkonfiguration nicht gefunden',
        message:
          'Die angeforderte Kundenkonfiguration <strong>{{tenantName}}</strong> ist nicht verfügbar. Verwenden Sie die korrekte URL?',
      },
      serviceUnavailable: {
        headline: 'Service vorübergehend nicht verfügbar',
        message:
          'Diese Anwendung wird derzeit gewartet. Bitte versuchen Sie es später erneut.',
      },
      networkError: {
        headline: 'Netzwerkfehler',
        message:
          'Ein Netzwerkfehler hat das Laden der Anwendung verhindert. Bitte überprüfen Sie Ihre Netzwerkverbindung und versuchen Sie es erneut.',
      },
      plannedMaintenance: {
        headline: 'Der Dienst wird gewartet',
        message:
          'Diese Anwendung wird derzeit planmäßig gewartet. Bitte versuchen Sie es später erneut.',
      },
    },
    tenantNotFoundError: {
      headline: 'Kundenkonfiguration nicht gefunden',
      message:
        'Die angeforderte Kundenkonfiguration <strong>{{tenantName}}</strong> ist nicht verfügbar. Verwenden Sie die korrekte URL?',
      action: 'Seite neu laden',
    },
    networkError: {
      message:
        'Verbindung zum Server nicht möglich. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
    },
    tenantConfigurationLoading: {
      headline: 'Lade Konfiguration',
    },
    tenantPortalDataLoading: {
      headline: 'Lade Portal-Daten',
    },
    notifications: {
      goToPage: 'Zur Seite wechseln',
      copyContentId: {
        success: 'ID in die Zwischenablage kopiert.',
        error:
          'ID konnte nicht in die Zwischenablage kopiert werden. Bitte manuell kopieren: {{id}}',
      },
      export: {
        error:
          'Export <strong>{{fileName}}</strong> konnte nicht erfolgreich heruntergeladen werden.',
        loading: 'Erstelle Export <strong>{{fileName}}</strong>.',
        success:
          'Export <strong>{{fileName}}</strong> wurde erfolgreich heruntergeladen.',
      },
      filterPersistence: {
        error: 'Aktuelle Filterauswahl konnte nicht gespeichert werden.',
        loading: 'Aktuelle Filterauswahl wird gespeichert.',
        success: 'Aktuelle Filterauswahl wurde erfolgreich gespeichert.',
      },
      bulkDownload: {
        error: 'Downloadarchiv konnte nicht erstellt werden.',
        loading_one: 'Erstelle Downloadarchiv für {{count}} Dokument.',
        loading_other: 'Erstelle Downloadarchiv für {{count}} Dokumente.',
        success_one: 'Starte Download von Archiv für {{count}} Dokument.',
        success_other: 'Starte Download von Archiv für {{count}} Dokumente.',
      },
      downloadRow: {
        error: 'Tabellendaten konnten nicht geladen werden: {{- message}}.',
        loading_one: 'Lade Daten für {{count}} Zeile.',
        loading_other: 'Lade Daten für {{count}} Zeilen.',
        success_one: 'Starte Download der Daten für {{count}} Zeile.',
        success_other: 'Starte Download der Daten für {{count}} Zeilen.',
      },
      rowRequest: {
        error:
          'Die Aktion "{{label}}" konnte nicht ausgeführt werden: {{- message}}.',
        loading_one: 'Sende "{{label}}"-Anfrage.',
        loading_other: 'Sende "{{label}}"-Anfrage für {{count}} Zeilen.',
        success_one: '"{{label}}"-Anfrage erfolgreich ausgeführt.',
        success_other:
          '"{{label}}"-Anfrage für {{count}} Zeilen erfolgreich ausgeführt.',
      },
      markAsRead: {
        error_one: 'Dokument konnte nicht als gelesen markiert werden.',
        error_other:
          '{{count}} Dokumente konnten nicht als gelesen markiert werden.',
        success_one: 'Dokument wurde erfolgreich als gelesen markiert.',
        success_other:
          '{{count}} Dokumente wurden erfolgreich als gelesen markiert.',
      },
      markAsUnread: {
        error_one: 'Dokument konnte nicht als ungelesen markiert werden.',
        error_other:
          '{{count}} Dokumente konnten nicht als ungelesen markiert werden.',
        success_one: 'Dokument wurde erfolgreich als ungelesen markiert.',
        success_other:
          '{{count}} Dokumente wurden erfolgreich als ungelesen markiert.',
      },
      delete: {
        error_one: 'Zeile konnte nicht gelöscht werden.',
        error_other: '{{count}} Zeilen konnten nicht gelöscht werden.',
        success_one: 'Zeile wurde erfolgreich gelöscht.',
        success_other: '{{count}} Zeilen wurden erfolgreich gelöscht.',
      },
      documentDownload: {
        loading:
          'Das Dokument <strong>{{fileName}}</strong> wird heruntergeladen.',
        success:
          'Das Dokument <strong>{{fileName}}</strong> wurde erfolgreich heruntergeladen.',
        error:
          'Das Dokument <strong>{{fileName}}</strong> konnte nicht erfolgreich heruntergeladen werden.',
      },
      staticFileDownload: {
        loading: 'Datei wird heruntergeladen.',
        success: 'Datei wurde erfolgreich heruntergeladen.',
        error: 'Datei konnte nicht heruntergeladen werden.',
      },
      inlineEdit: {
        loading: 'Änderung wird gespeichert.',
        success: 'Änderung wurde gespeichert.',
        error: 'Änderung konnte nicht gespeichert werden.',
      },
      maintenance: {
        title: 'Wartungsmodus',
        plannedMaintenanceMessage:
          'Diese Anwendung wird derzeit planmäßig gewartet. Bitte versuchen Sie es später erneut.',
        message:
          'Diese Anwendung wird derzeit gewartet. Bitte versuchen Sie es später erneut.',
        action: 'Seite neu laden',
      },
    },
    dataRefresh: {
      dataRefreshlabel: 'Letzte Datenaktualisierung',
      closedQuarterLabel: 'Letztes abgeschlossenes Quartal',
      tooltip:
        'Letzte Datenaktualisierung: {{formattedRefreshDate}}\nLetztes abgeschlossenes Quartal: {{formattedClosedQuarterDate}}',
      tooltipWithDataRefresh:
        'Letzte Datenaktualisierung: {{formattedRefreshDate}}',
      tooltipWithClosedQuarted:
        'Letztes abgeschlossenes Quartal: {{formattedClosedQuarterDate}}',
    },
    disclaimer: {
      accept: 'Zustimmen',
      cancel: 'Abbrechen',
      defaultTitle: 'Nutzungsbedingungen',
    },
    detailPageCreationModal: {
      title: 'Vergleichseinstellungen',
      cancel: 'Abbrechen',
      apply: 'Vergleichen',
      layoutLabel: 'Layout',
      filteredRowsWarning:
        'Einige ausgewählte Zeilen wurden ausgeschlossen, da sie für dieses Layout keine Daten oder doppelte Kennungen haben.',
    },
    widget: {
      action: {
        label: {
          additionalInformation: 'Weiterführende Informationen',
          bulkActions: 'Weitere Aktionen',
          closeFullscreen: 'Vollbildmodus beenden',
          downloadCsvFiltered: 'Gefilterte Daten als CSV herunterladen',
          downloadCsvUnfiltered: 'Alle Daten als CSV herunterladen',
          downloadCsvSelectedRows: 'Ausgewählte Zeilen als CSV herunterladen',
          customFilter: 'Tabellenfilter konfigurieren',
          customization: 'Tabelle konfigurieren',
          delete: 'Löschen',
          download: 'Dokumente herunterladen',
          edit: 'Bearbeiten',
          downloadXlsxFiltered: 'Gefilterte Daten als Excel XLSX herunterladen',
          downloadXlsxSelectedRows:
            'Ausgewählte Zeilen als Excel XLSX herunterladen',
          downloadXlsxReadOnly:
            'Gefilterte Daten als schreibgeschütztes Excel XLSX herunterladen',
          downloadXlsxUnfiltered: 'Alle Daten als Excel XLSX herunterladen',
          downloadGroupDataXlsx: 'Gruppendaten als Excel XLSX herunterladen',
          downloadGroupDataCsv: 'Gruppendaten als CSV herunterladen',
          imageDownload: 'Als Bild exportieren',
          imageDownloadWithBackground: 'Als Bild mit Hintergrund exportieren',
          initFoundOperation: 'Fund Operation erstellen',
          markAsRead: 'Als gelesen markieren',
          markAsUnread: 'Als ungelesen markieren',
          openInFullscreen: 'Im Vollbildmodus öffnen',
          shareActions: 'Daten exportieren',
          createRow: 'Zeile erstellen',
          createInvestmentLimit: 'Limit erstellen',
          dataIngestion: 'Dateneingabeprozess erstellen',
          downloadStaticFile: 'Herunterladen',
          copyContentId: 'Content-ID kopieren (API)',
          openDetailPage: 'Detail-Seite für {{label}} öffnen',
          compareData: 'Daten vergleichen',
          aggregateData: 'Daten aggregieren',
          moveContentUp: 'Inhalt nach oben verschieben',
          moveContentDown: 'Inhalt nach unten verschieben',
          toggleContentWidth: 'Inhaltsbreite umschalten',
          duplicateContent: 'Inhalt duplizieren',
          removeContent: 'Inhalt entfernen',
        },
        tooltip: {
          compareData:
            'Wählen Sie mindestens zwei Zeilen aus, um Daten zu vergleichen',
          aggregateData:
            'Wählen Sie mindestens zwei Zeilen aus, um Daten zu aggregieren',
          downloadCsvUnfiltered:
            'Alle Daten werden ungefiltert als CSV heruntergeladen. Nur sichtbare Tabellenspalten sind im Export enthalten. Aktive Tabellenanpassungen werden berücksichtigt.',
          downloadCsvFiltered:
            'Gefilterte Datenansicht wird als CSV heruntergeladen. Nur sichtbare Tabellenspalten sind im Export enthalten. Aktive Tabellenanpassungen werden berücksichtigt.',
          downloadCsvSelectedRows:
            'Nur die aktuell ausgewählten Zeilen werden als CSV heruntergeladen. Aktive Tabellenanpassungen bleiben berücksichtigt.',
          downloadXlsxFiltered:
            'Gefilterte Datenansicht wird als Excel XLSX heruntergeladen. Nur sichtbare Tabellenspalten sind im Export enthalten. Aktive Tabellenanpassungen werden berücksichtigt.',
          downloadXlsxSelectedRows:
            'Nur die aktuell ausgewählten Zeilen werden als Excel XLSX heruntergeladen. Aktive Tabellenanpassungen bleiben berücksichtigt.',
          downloadXlsxUnfiltered:
            'Alle Daten werden ungefiltert als Excel XLSX heruntergeladen. Nur sichtbare Tabellenspalten sind im Export enthalten. Aktive Tabellenanpassungen werden berücksichtigt.',
          downloadXlsxReadOnly:
            'Gefilterte Datenansicht wird als schreibgeschütztes Excel XLSX heruntergeladen. Nur sichtbare Tabellenspalten sind im Export enthalten. Aktive Tabellenanpassungen werden berücksichtigt.',
          downloadGroupDataXlsx:
            'Nur die aggregierten Gruppenzeilen werden als Excel XLSX heruntergeladen. Einzelne Datenzeilen sind nicht enthalten.',
          downloadGroupDataCsv:
            'Nur die aggregierten Gruppenzeilen werden als CSV heruntergeladen. Einzelne Datenzeilen sind nicht enthalten.',
          copyContentId:
            'Die Daten dieses Widgets können über unsere API anhand der Content-ID abgerufen werden.',
        },
      },
    },
    upload: {
      zipUploadModal: {
        headline: 'Dokumente hochladen',
      },
      title_one:
        'Ziehen Sie eine Datei per Drag-and-Drop hierher oder klicken Sie, um eine ',
      title_other:
        'Ziehen Sie Dateien per Drag-and-Drop hierher oder klicken Sie, um ',
      subtitle_one: 'Datei auszuwählen.',
      subtitle_other: 'Dateien auszuwählen.',
      permittedFormats: 'Zulässige Dateiformate',
      maxFileSize: 'Max. Dateigröße',
      maxTotalSize: 'Max. Gesamtgröße',
      maxTotalSizeExceeded:
        'Die Gesamtgröße des Uploads darf {{maxTotalSize}} nicht überschreiten.',
      maxFileCount: 'Max. Dateianzahl',
      upload: 'Hochladen',
      uploadDocuments: 'Dokumente hochladen',
      uploading: 'Wird hochgeladen',
      fetchingMetadata: 'Laden',
      cancel: 'Abbrechen',
      close: 'Schließen',
      okay: 'OK',
      uploadFailed: 'Hochladen fehlgeschlagen',
      rejected: 'Abgelehnte Dateien',
      addedToUpload: 'Hochzuladende Dateien',
      fileSummary_one: '{{ count }} Datei | {{ totalFileSize }}',
      fileSummary_other: '{{ count }} Dateien | {{ totalFileSize }}',
      info: {
        progress_one: 'Datei wurde erfolgreich hochgeladen.',
        progress_other:
          '{{ count }} von {{ total, number }} Dateien wurden erfolgreich hochgeladen.',
        problemCount_one: 'Es gab ein Problem beim Hochladen einer Datei.',
        problemCount_other:
          'Es gab ein Problem beim Hochladen von {{count}} Dateien.',
      },
      uploadedFiles: 'Hochgeladene Dateien',
      conditionalFilterOptionsError:
        'Beim Laden der Metadaten ist ein Systemfehler aufgetreten. Bitte brechen Sie den Vorgang ab und versuchen Sie es erneut.',
      uploadZip: 'ZIP-Archiv hochladen',
      back: 'Zurück',
      extractMetaData: {
        title: 'Metadaten aus dem Dokument gelesen',
        checkBtnLabel: 'Dateispezifische Metadaten überprüfen',
        fileName: 'Dateiname',
        size: 'Dateigröße',
        totalFiles_one: 'Metadaten der Datei wurden erfolgreich ausgelesen.',
        totalFiles_other:
          'Metadaten aus {{success, number}} von {{count}} Dateien wurden erfolgreich ausgelesen.',
        failedToExtract_one:
          'Beim Festlegen der Metadaten für die Datei ist ein Fehler aufgetreten.',
        failedToExtract_other:
          'Beim Festlegen der Metadaten für {{count}} Dateien ist ein Fehler aufgetreten.',
      },
      noFiles: 'Keine Dateien zum Hochladen ausgewählt',
      hideAndSelectAllFieldError:
        'Das Feld {{title}} ist als „Alle ausblenden und auswählen“ konfiguriert, wodurch nur maximal 10 Elemente unterstützt werden.',
      metadataExtractinConfig: {
        label: 'Metadaten automatisch vorausfüllen',
        renameFilesLabel: 'Dateien gemäß Namenskonvention umbenennen',
        configOption: {
          fromAI: 'anhand des Dateiinhalts',
          fromFileName: 'anhand des Dateinamens',
          fromUser: 'nicht automatisch vorausfüllen',
        },
      },
      documentPreview: {
        title: 'Dokumentvorschau',
        aiExtractionExplanation: 'Erklärungen zur KI-Extraktion',
      },
    },
    backToPage: 'Zurück zur Seite',
    forms: {
      placeholders: {
        text: 'Bitte Wert eingeben',
        textarea: 'Bitte Text eingeben',
        number: 'Bitte Zahl eingeben (z. B. {{example}})',
        select: 'Bitte Wert auswählen',
        creatableSelect: 'Bitte Wert auswählen oder eingeben',
        date: 'Bitte Datum auswählen',
        datetime: 'Bitte Datum und Uhrzeit auswählen',
      },
      validationErrors: {
        inputIsRequired: 'Eingabe benötigt',
        minMaxNumberError: 'Erwartet {{expected}}',
        exclusiveMaximumError: 'Muss kleiner als {{expected}} sein',
        exclusiveMinimumError: 'Muss größer als {{expected}} sein',
        maximumError: 'Darf höchstens {{expected}} sein',
        minimumError: 'Muss mindestens {{expected}} sein',
        patternError: 'Muss dem Muster {{pattern}} entsprechen',
        minDateError: 'Das Datum darf nicht vor {{date}} liegen',
        maxDateError: 'Das Datum darf nicht nach {{date}} liegen',
        shouldBeMaxError:
          'Das Maximum aller Teilverkäufe sollte nicht vor dem Ausstiegsdatum liegen.',
      },
    },
    updateTableRow: {
      title_one: 'Eintrag bearbeiten ({{count}} Element)',
      title_other: 'Einträge bearbeiten ({{count}} Elemente)',
      titleForTypeDoc_one: 'Dokument bearbeiten ({{count}} Element)',
      titleForTypeDoc_other: 'Dokumente bearbeiten ({{count}} Elemente)',
      updateError_one: 'Fehler beim Aktualisieren des Eintrags',
      updateError_other: 'Fehler beim Aktualisieren von {{count}} Einträgen',
      cancel: 'Abbrechen',
      submit: 'Abschicken',
    },
    navigation: {
      dynamicNavSection: {
        title: 'Detail-Seiten',
        closeAll: 'Alle schließen',
        errorNotification: 'Fehler beim Schließen der Detail-Seiten',
      },
    },
    dashboard: {
      topNavigation: {
        addDashboard: 'Dashboard hinzufügen',
        allDashboards: 'Alle Dashboards ({{count}})',
      },
      allDashboardsModal: {
        title: 'Alle Dashboards',
        instanceSectionTitle: 'Dashboards in der oberen Navigation',
        availableSectionTitle: 'Weitere verfügbare Dashboards',
        instanceSectionEmpty:
          'In der oberen Navigation werden keine Dashboards angezeigt.',
        availableSectionEmpty: 'Keine weiteren Dashboards verfügbar.',
        sharingPrivate: 'Privat',
        sharingGlobal: 'Global',
        moveUp: 'Nach oben',
        moveDown: 'Nach unten',
        hideTab: 'Tab ausblenden',
        showTab: 'Tab anzeigen',
        delete: 'Löschen',
        restore: 'Wiederherstellen',
        cancel: 'Abbrechen',
        save: 'Speichern',
        saveSuccess: 'Dashboard-Navigation aktualisiert.',
        actionFailed:
          'Die Dashboard-Navigation konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.',
      },
      createModal: {
        title: 'Dashboard erstellen',
        nameLabel: 'Dashboard-Name',
        descriptionLabel: 'Beschreibung',
        cancel: 'Abbrechen',
        submit: 'Dashboard erstellen',
        submitFailed:
          'Das Dashboard konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
        createInstanceFailed:
          'Das Dashboard wurde erstellt, konnte aber nicht zur oberen Navigation hinzugefügt werden. Sie können es über „Alle Dashboards“ anzeigen.',
      },
      deleteConfirmation: {
        title: 'Dashboard löschen',
        message: '"{{dashboardName}}" endgültig löschen?',
        irreversibleWarning:
          'Das Dashboard wird gelöscht, nachdem Speichern geklickt wurde.',
        permanentWarning: 'Diese Aktion kann nicht rückgängig gemacht werden.',
        cancel: 'Abbrechen',
        confirm: 'Löschen',
        deleteFailed:
          'Das Dashboard konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.',
        deleteSuccess: 'Dashboard gelöscht.',
      },
      shareModal: {
        title: 'Dashboard teilen',
        instruction: 'Wählen Sie, wer dieses Dashboard sehen kann.',
        privateLabel: 'Privat',
        privateDescription: 'Nur für Sie sichtbar',
        globalLabel: 'Global',
        globalDescription: 'Für alle Mitglieder der Organisation verfügbar',
        submitFailed:
          'Die Freigabeeinstellungen konnten nicht aktualisiert werden. Bitte versuchen Sie es erneut.',
        submitSuccess: 'Freigabeeinstellungen aktualisiert.',
      },
      emptyState: {
        noDashboards: {
          title: 'Erstellen Sie Ihr erstes Dashboard',
          description:
            'Erstellen Sie ein Dashboard, um eine individuelle Ansicht auf Ihre Daten zu erhalten.',
          action: 'Dashboard erstellen',
        },
        noInstances: {
          title: 'Dashboard auswählen',
          description:
            'Öffnen Sie Alle Dashboards, um ein Dashboard für Ihre Hauptnavigation auszuwählen.',
          action: 'Alle Dashboards',
        },
        emptyDashboard: {
          title: 'Dieses Dashboard ist leer',
          descriptionOwner:
            'Fügen Sie eine Komponente hinzu, um Ihr Dashboard aufzubauen.',
          descriptionViewer: 'Dieses Dashboard enthält noch keine Komponenten.',
          action: 'Komponente hinzufügen',
        },
      },
      loading: 'Dashboard wird geladen…',
      editAction: {
        label: {
          editLayout: 'Layout bearbeiten',
          cancel: 'Abbrechen',
        },
        saveFailed:
          'Das Dashboard konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
        saveOutcomeUnknown:
          'Speichern kann erfolgreich oder fehlgeschlagen sein. Dashboard wird neu geladen — bearbeiten Sie weiter, falls Ihre Änderungen noch nötig sind.',
      },
      placeholder: {
        pendingHydration: 'Diese Komponente wird nach dem Speichern geladen.',
      },
      unsavedChanges:
        'Sie haben ungespeicherte Dashboard-Änderungen. Ohne Speichern fortfahren?',
      unsavedChangesModal: {
        title: 'Ungespeicherte Änderungen',
        message:
          'Sie haben ungespeicherte Dashboard-Layoutänderungen. Bleiben Sie, um weiter zu bearbeiten, oder verwerfen Sie sie und verlassen Sie die Ansicht.',
        stay: 'Bleiben',
        discard: 'Verwerfen',
      },
    },
    initFundOperation: {
      title: 'Fund Operation erstellen',
      cancel: 'Abbrechen',
      submit: 'Abschicken',
      successMessage: 'Die Fund Operation wurde erfolgreich erstellt.',
      fundLoadingError:
        'Beim Laden der Funddaten ist ein Systemfehler aufgetreten. Bitte brechen Sie den Vorgang ab und versuchen Sie es erneut.',
      currencyLoadingError:
        'Beim Laden der Währungsdaten ist ein Systemfehler aufgetreten. Bitte brechen Sie den Vorgang ab und versuchen Sie es erneut.',
      error:
        'Es ist ein Systemfehler aufgetreten. Bitte brechen Sie den Vorgang ab und versuchen Sie es erneut.',
    },
    createRow: {
      title: 'Zeile erstellen',
      fileUploadRequired: 'Es muss mindestens eine Datei ausgewählt werden.',
      cancel: 'Abbrechen',
      submit: 'Abschicken',
      okay: 'OK',
      submitting: 'Wird gesendet',
    },
    investmentLimit: {
      title: 'Limit erstellen',
      viewTitle: 'Limitübersicht',
      close: 'Schließen',
      cancel: 'Abbrechen',
      back: 'Zurück',
      next: 'Weiter',
      create: 'Limit erstellen',
      creating: 'Wird erstellt',
      steps: {
        overview: 'Allgemeine Einstellungen',
        parameter: 'Parameter',
        denominator: 'Nenner',
        workflow: 'Workflow und Gültigkeit',
        review: 'Zusammenfassung',
      },
      widgets: {
        overview: 'Überblick',
        comparisonType: 'Vergleichstyp',
        limitParameters: 'Limitparameter',
        evaluation: 'Auswertung',
        denominator: 'Nenner',
        workflow: 'Workflow',
        validity: 'Gültigkeit',
        review: 'Prüfung',
      },
      mode: {
        aggregation: {
          label: 'Aggregationslimit',
          description:
            'Aggregiert einen oder mehrere Datensätze, bevor das Ergebnis mit einem Limit verglichen wird.',
        },
        position: {
          label: 'Positionslimit',
          description:
            'Bewertet jeden Datensatz einzeln anhand einer Regel oder eines Schwellenwerts.',
        },
        exclusion: {
          label: 'Ausschluss',
          description:
            'Verbietet Engagements nach Land, Strategie, Region oder Branche.',
        },
        inclusion: {
          label: 'Einschluss',
          description:
            'Erlaubt Engagements nur im angegebenen Land, in der angegebenen Strategie, Region oder Branche.',
        },
      },
      valueType: {
        absolute: {
          label: 'Absolut',
          description: 'Vergleicht den gemessenen Wert direkt mit dem Limit.',
        },
        relative: {
          label: 'Relativ',
          description:
            'Vergleicht den gemessenen Wert als Anteil eines Nenners.',
        },
      },
      limitType: {
        regulatory: 'Regulatorisch',
        contractual: 'Vertraglich',
        client_specific: 'Kundenspezifisch',
        internal: 'Intern',
      },
      aggregationMethod: {
        sum: 'Summe',
        topN: 'Top N',
        bottomN: 'Bottom N',
      },
      dataField: {
        available_capital: 'Verfügbares Kapital',
        cumulative_all_commitment: 'Kumuliertes Gesamtcommitment',
        cumulative_all_cost: 'Kumulierte Gesamtkosten',
        cumulative_all_paid_in_inside_commitment:
          'Kumulierte Einzahlungen innerhalb des Commitments',
        cumulative_all_returned: 'Kumulierte Rückflüsse',
        days_to_final_termination_date:
          'Tage bis zum endgültigen Beendigungsdatum',
        days_to_investment_end_date: 'Tage bis zum Investitionsende',
        days_to_termination_date: 'Tage bis zum Beendigungsdatum',
        dpi: 'DPI',
        effective_valuation: 'Effektive Bewertung',
        exposure: 'Exposure',
        irr: 'IRR',
        nbr_count: 'Anzahl',
        rvpi: 'RVPI',
        tvpi: 'TVPI',
        undrawn_commitment: 'Nicht abgerufenes Commitment',
      },
      fields: {
        limitName: 'Limitname',
        limitNamePlaceholder: 'z. B. Max. PE-Fondsallokation',
        description: 'Beschreibung',
        descriptionPlaceholder: 'Beschreiben Sie den Zweck dieses Limits',
        limitType: 'Limittyp',
        selectType: 'Typ auswählen',
        dataLevel: 'Datenebene',
        selectLevel: 'Ebene auswählen',
        currencyType: 'Währungstyp',
        selectCurrencyType: 'Währungstyp auswählen',
        removeFilter: 'Filter entfernen',
        selectNamed: '{{label}} auswählen',
        kpi: 'KPI',
        selectKpi: 'KPI auswählen',
        requiresDataLevel: 'Erfordert Auswahl der Datenebene',
        limitOperator: 'Limitoperator',
        operatorPlaceholder: 'Op.',
        limitValue: 'Limitwert',
        valuePlaceholder: 'Wert',
        warningThreshold: 'Warnschwelle',
        warningPlaceholder: 'z. B. 80 %',
        aggregationMethod: 'Aggregationsmethode',
        selectMethod: 'Methode auswählen',
        aggregationNumber: 'Anzahl der Aggregationsmethode',
        aggregationNumberPlaceholder: 'z. B. 10',
        evaluationMetric: 'Auswertungskennzahl',
        selectMetric: 'Kennzahl auswählen',
        evaluationOperator: 'Auswertungsoperator',
        evaluationValue: 'Auswertungswert',
        breachApproval: 'Genehmigung bei Limitverletzung',
        validFrom: 'Gültig ab',
        selectStartDate: 'Startdatum auswählen',
        validTo: 'Gültig bis',
        selectEndDate: 'Enddatum auswählen',
        validIndefinitely: 'Unbegrenzt gültig (kein Enddatum)',
      },
      review: {
        none: 'Keine',
        yes: 'Ja',
        no: 'Nein',
        indefinitely: 'Unbegrenzt',
        limitName: 'Limitname',
        limitType: 'Limittyp',
        limitMode: 'Limitmodus',
        description: 'Beschreibung',
        comparisonType: 'Vergleichstyp',
        dataLevel: 'Datenebene',
        currencyType: 'Währungstyp',
        filters: 'Filter',
        kpi: 'KPI',
        limitOperator: 'Limitoperator',
        limitValue: 'Limitwert',
        warningThreshold: 'Warnschwelle',
        aggregationMethod: 'Aggregationsmethode',
        aggregationNumber: 'Anzahl der Aggregationsmethode',
        evaluationMetric: 'Auswertungskennzahl',
        evaluationOperator: 'Auswertungsoperator',
        evaluationValue: 'Auswertungswert',
        breachApproval: 'Genehmigung bei Limitverletzung',
        validFrom: 'Gültig ab',
        validTo: 'Gültig bis',
      },
      preview: {
        dataSource: 'Datenquelle',
        addFilter: 'Filter hinzufügen',
        topLevelAggregation: 'Aggregation auf oberster Ebene',
        singlePositionExpression: 'Auswertung einer einzelnen Position',
        kpiLimitComparison: 'KPI vs. Limitvergleich',
        overview: 'Überblick',
        parameter: 'Parameter',
        denominator: 'Nenner',
        workflow: 'Workflow und Gültigkeit',
        limitMode: 'Limitmodus',
        denominatorFieldsHint:
          'Die Auswertungsfelder werden im Schritt Nenner festgelegt.',
        inclusionBreachHint:
          'Das Limit gilt als verletzt, wenn in der Datenquelle Einträge gefunden werden, die nicht den angegebenen Filtern entsprechen.',
        exclusionBreachHint:
          'Das Limit gilt als verletzt, wenn in der Datenquelle Einträge gefunden werden, die den angegebenen Filtern entsprechen.',
        denominatorIntro:
          'Wählen Sie die Datenquelle, die als Basis für die relative Berechnung dient.',
        allRecords:
          'Datensätze für den ausgewählten Währungstyp werden unten angezeigt.',
        filteredRecords:
          'Betroffene Datensätze für den ausgewählten Währungstyp anhand der hinzugefügten Filter.',
        previewPlaceholder:
          'Hier erscheint eine Vorschau der betroffenen Einträge, sobald eine Datenebene und ein Währungstyp ausgewählt sind.',
        currencyTypePreviewPlaceholder:
          'Wählen Sie einen Währungstyp, um die Vorschau zu laden. Die Vorschau enthält nur Datensätze für diesen Währungstyp.',
      },
      createFailed: 'Das Limit konnte nicht erstellt werden.',
    },
    dataIngestion: {
      title: 'Neuer Datenimport',
      cancel: 'Abbrechen',
      back: 'Zurück',
      next: 'Weiter',
      upload: 'Datei hochladen & verarbeiten',
      uploading: 'Wird hochgeladen',
      done: 'Fertig',
      configureAndDownload: {
        title: 'Konfigurieren & Herunterladen',
        configureImport: 'Import-Metadaten festlegen',
        noImportConfig:
          'Der aktuelle Datenimport erfordert keine zusätzliche Konfiguration.',
        selectScope: 'Optional: Vorausgefüllte Vorlage herunterladen',
        entitiesLabel: 'Entitäten zum Herunterladen vorausgefüllter Vorlagen',
        prefillDataLabel: 'Mit aktuellen Dateneinträgen herunterladen',
        prefillDataHelpText:
          'Wenn diese Option aktiviert ist, werden die neuesten verfügbaren Daten basierend auf dem Import-Referenzdatum in der Vorlage vorausgefüllt.',
        downloadTemplate: 'Vorlage herunterladen',
        templateDownload: {
          loading: 'Lade Datenimport-Vorlage herunter',
          success: 'Download der Datenimport-Vorlage gestartet',
          error:
            'Die Datenimport-Vorlage konnte nicht heruntergeladen werden: {{- message}}',
        },
      },
      uploadAndParse: {
        title: 'Hochladen & Daten verarbeiten',
        templateInput: 'Vorlagen-Eingabe',
        executionLog: 'Importprotokoll',
        executionLogPlaceholder:
          'Das Ergebnis des Imports wird hier angezeigt sobald der Upload abgeschlossen ist.',
        executionLogSuccess: 'Import erfolgreich abgeschlossen.',
        executionLogErrorFallback:
          'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
      },
    },
    pageSidebar: {
      widgetTitle: 'Details',
      closeSidebar: 'Seitenleiste schließen',
      pinSidebar: 'Seitenleiste anheften',
      unpinSidebar: 'Seitenleiste lösen',
      noDocumentsAvailable: 'Keine Dokumente verfügbar',
      noPreviewAvailable: 'Keine Vorschau verfügbar',
      previewUnavailableNotScanned:
        'Diese Datei wurde nicht auf schädliche Inhalte geprüft. Vorschau ist nicht verfügbar.',
      previewUnavailableMalicious:
        'Diese Datei kann schädliche Inhalte enthalten und wurde gesperrt. Vorschau ist nicht verfügbar.',
      download: 'Download',
      openInPage: 'In Dokumentenmanagement öffnen',
      errorText:
        'Beim Laden der zugehörigen Dokumente ist ein Problem aufgetreten.',
    },
    aiAssistant: {
      addCurrentPage: 'Seite hinzufügen',
      addDocuments_one: 'Dokument ({{count}}) hinzufügen',
      addDocuments_other: 'Dokumente ({{count}}) hinzufügen',
      allChats: 'Alle Chats',
      assistantTitle: 'AssetMetrix AI-Assistent',
      cancel: 'Abbrechen',
      chatListSectionLast30Days: 'Letzte 30 Tage',
      chatListSectionLast7Days: 'Letzte 7 Tage',
      chatListSectionOlder: 'Älter',
      chatListSectionToday: 'Heute',
      chatListSectionYesterday: 'Gestern',
      closeAssistant: 'Assistent schließen',
      closeSources: 'Quellen schließen',
      collapseCitations: 'Zitate ausblenden',
      copied: 'Kopiert',
      copyReply: 'Antwort in die Zwischenablage kopieren',
      composerPlaceholder: 'Fragen Sie den AssetMetrix AI-Assistenten…',
      deleteChat: 'Chat löschen',
      deleteChatConfirm: 'Chat löschen',
      deleteChatMessage:
        'Möchten Sie diesen Chat wirklich löschen? Dies kann nicht rückgängig gemacht werden.',
      deleteChatMessageNamed:
        'Möchten Sie „{{title}}“ wirklich löschen? Dies kann nicht rückgängig gemacht werden.',
      disclaimer:
        'Sie interagieren mit einem System der Künstlichen Intelligenz (KI).',
      disclaimerParagraphs: [
        'Sie interagieren mit einem System der Künstlichen Intelligenz (KI). Antworten werden ausschließlich auf Basis von Inhalten und Daten erzeugt, auf die Sie innerhalb der AssetMetrix Platform zugriffsberechtigt sind. Obwohl der Assistent hilfreiche und möglichst genaue Informationen liefern soll, können Antworten unvollständig oder ungenau sein und stellen keine Rechts-, Finanz-, Regulierungs- oder Fachberatung dar. Der AI-Assistent unterstützt die menschliche Einschätzung und Fachberatung, ersetzt sie aber nicht. Die endgültige Verantwortung für alle Entscheidungen und Handlungen liegt beim Nutzer.',
        'Prüfen Sie wichtige Informationen stets, bevor Sie Entscheidungen treffen. Der AI-Assistent respektiert strikt die Benutzerberechtigungen und kann nicht auf Inhalte außerhalb Ihrer Zugriffsberechtigung zugreifen.',
      ],
      disclaimerTitle: 'Hinweis zum AI-Assistenten',
      downloadAllDocuments: 'Alle Dokumente als ZIP herunterladen',
      downloadDocument: 'Dokument herunterladen',
      expandCitations: 'Zitate anzeigen',
      hideChatList: 'Chatliste ausblenden',
      hideSources: 'Quellen ausblenden ({{count}})',
      jumpToSource: 'Zur Quelle {{index}} springen',
      loadingChats: 'Chats werden geladen…',
      newChat: 'Neuer Chat',
      open: 'Öffnen',
      openAssistant: 'AssetMetrix AI-Assistent öffnen',
      openInPreview: 'In Vorschau öffnen',
      overlapPageContent: 'Seiteninhalt überlagern',
      pinToPageLayout: 'An Seitenlayout anheften',
      removeDocumentContext: '{{label}} entfernen',
      removePageContext: '{{label}} entfernen',
      requestError:
        'Die Anfrage an den AI-Assistenten ist fehlgeschlagen. Bitte versuchen Sie es erneut.',
      sendMessage: 'Nachricht senden',
      showChatList: 'Chatliste anzeigen',
      showSources: 'Quellen anzeigen ({{count}})',
      sourcesDocumentCount_one: '{{count}} Dokument',
      sourcesDocumentCount_other: '{{count}} Dokumente',
      sourcesLinkCount_one: '{{count}} Link',
      sourcesLinkCount_other: '{{count}} Links',
      sourcesTitle: 'Quellen ({{count}})',
      sourcesTitleDocumentsAndLinks: 'Quellen ({{documents}}, {{links}})',
      sourcesTitleLinks_one: 'Quellen ({{count}} Link)',
      sourcesTitleLinks_other: 'Quellen ({{count}} Links)',
      thinking: 'Denke nach…',
    },
    pdfDocumentPreview: {
      close: 'Vorschau schließen',
      closeSearch: 'Suche schließen',
      currentPage: 'Aktuelle Seite',
      disableHandTool: 'Hand-Werkzeug deaktivieren',
      documentDetails: 'Dokumentdetails',
      download: 'Herunterladen',
      fitPage: 'Ganze Seite',
      fitWidth: 'Seitenbreite',
      handTool: 'Hand-Werkzeug (Verschieben)',
      hideDocumentDetails: 'Dokumentdetails ausblenden',
      hidePages: 'Seiten ausblenden',
      horizontalLayout: 'Horizontale Ansicht',
      loading: 'Dokument wird geladen…',
      loadingError: 'Dieses Dokument konnte nicht geladen werden.',
      moreTools: 'Weitere Werkzeuge',
      nextMatch: 'Nächster Treffer',
      noResults: 'Keine Ergebnisse',
      previousMatch: 'Vorheriger Treffer',
      print: 'Drucken',
      rotate: 'Drehen',
      search: 'Suchen',
      searchPlaceholder: 'Im Dokument suchen…',
      searchTitle: 'Suchen (Strg/Cmd+F)',
      showPages: 'Seiten anzeigen',
      title: 'Dokumentvorschau',
      verticalLayout: 'Vertikale Ansicht',
      zoomIn: 'Vergrößern',
      zoomOut: 'Verkleinern',
    },
    vegaChartWidget: {
      groupingError:
        'Für die Datenspalten ist keine Spaltengruppierung konfiguriert',
    },
    textFromTableWidget: {
      errorLoadingData: 'Dynamischer Text konnte nicht geladen werden',
      missingColumnConfig:
        'Fehlende Spaltenkonfiguration für Platzhalter: {{keys}}',
      noDataFound: 'Keine Daten gefunden',
    },
    stakeAdjustment: {
      label: 'Anteilsadjustiert',
      tooltip:
        'Alle Investmentdaten auf den direkten Anteil des Investors anpassen',
    },
  },
} as const;

export default de;
